import React from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { makeStyles } from '@material-ui/styles';

import { ICON_NAMES, MaterialDesignIcon } from '../util/material-design-icons';

const DoubleArrowIcon = (props: any) => (
  <SvgIcon {...props}>
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M7 10 l5-5 5 5z" />
    <path d="M7 13 l5 5 5-5z" />
  </SvgIcon>
);

const ArrowDownIcon = () => <MaterialDesignIcon iconName={ICON_NAMES.ARROW_DROP_DOWN} />;

const ArrowUpIcon = () => <MaterialDesignIcon iconName={ICON_NAMES.ARROW_DROP_UP} />;

const useStyles = makeStyles(() => ({
  activeIcon: {
    color: '#e64a19 !important',
  },
  inactiveIcon: {
    fontSize: '18px',
    marginLeft: '4px',
    marginRight: '4px',
  },
}));

type InputProps<K> = {
  label: string;
  sortKey: K;
  currentSortBy: K;
  currentSortDirection: SortDirection;
  onSortByChange: (sortKey: K) => void;
  onSortDirectionChange: (sortDirection: SortDirection) => void;
};

export const UiSortLabel = <K extends string = string>({
  label,
  sortKey,
  currentSortBy,
  currentSortDirection,
  onSortByChange,
  onSortDirectionChange,
}: InputProps<K>) => {
  const classes = useStyles();

  const handleClick = () => {
    if (sortKey === currentSortBy) {
      onSortDirectionChange(currentSortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      onSortByChange(sortKey);
    }
  };

  const active = sortKey === currentSortBy;

  return (
    <TableSortLabel
      active={active}
      direction={currentSortDirection}
      IconComponent={currentSortDirection === 'desc' ? ArrowDownIcon : ArrowUpIcon}
      hideSortIcon
      onClick={handleClick}
      classes={{ icon: classes.activeIcon }}
    >
      {label} {!active && <DoubleArrowIcon className={classes.inactiveIcon} />}
    </TableSortLabel>
  );
};
